var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "TcAppointmentFormStart inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-2xl w-full px-5"
    },
    [
      _c("div", { staticClass: "py-10" }, [
        _c("div", { staticClass: "flex flex-col items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-green-400 text-white"
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-5 text-center w-full" }, [
            _c(
              "h2",
              {
                staticClass:
                  "text-3xl text-center font-bold mb-5 flex mx-auto justify-center items-center"
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "h-6 w-6 mr-3",
                    style: {
                      color: _vm.$root.delegationColor(
                        _vm.$parent.delegation.id
                      )
                    },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "currentColor"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$parent.delegation.name))])
              ]
            ),
            _vm._v(" "),
            _c(
              "h3",
              {
                staticClass: "text-2xl leading-6 font-medium text-gray-900",
                attrs: { id: "modal-title" }
              },
              [_vm._v("Solicitar cita previa")]
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-5 mb-3 w-10 mx-auto" }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2" }, [
              _c(
                "form",
                {
                  staticClass: "text-xl text-gray-500",
                  attrs: { action: "#", autocomplete: "off" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-center items-start mx-auto mb-3 gap-5"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "flex-1 font-bold text-right" },
                        [
                          _vm._v("Fecha"),
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.$parent.time_slot.date
                                .toLocaleString("es-ES", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric"
                                })
                                .replace(/de/g, "")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "flex-1 font-bold text-left" },
                        [
                          _vm._v("Hora"),
                          _c("br"),
                          _vm._v(_vm._s(_vm.$parent.time_slot.time))
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "types flex justify-center items-center my-5 gap-5"
                    },
                    [
                      _c("div", { staticClass: "flex-1 text-center" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$parent.type,
                              expression: "$parent.type"
                            }
                          ],
                          staticClass: "hidden",
                          attrs: {
                            type: "radio",
                            id: "typePhone",
                            value: "phone_call"
                          },
                          domProps: {
                            checked: _vm._q(_vm.$parent.type, "phone_call")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.$parent, "type", "phone_call")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "flex bg-gray-300 text-gray-400 py-3 rounded-md justify-center",
                            attrs: { for: "typePhone" }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-6 w-6 mr-2",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d:
                                      "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Telefónica")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1 textcenter" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$parent.type,
                              expression: "$parent.type"
                            }
                          ],
                          staticClass: "hidden",
                          attrs: {
                            type: "radio",
                            id: "typeFace",
                            value: "face"
                          },
                          domProps: {
                            checked: _vm._q(_vm.$parent.type, "face")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.$parent, "type", "face")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "flex bg-gray-300 text-gray-400 py-3 rounded-md justify-center",
                            attrs: { for: "typeFace" }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-6 w-6 mr-2",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d:
                                      "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                  }
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Presencial")])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.$parent.type == "phone_call"
                    ? _c("div", [
                        _c(
                          "label",
                          {
                            staticClass: "block text-left text-md mb-2",
                            attrs: { for: "phone" }
                          },
                          [_vm._v("Teléfono (*)")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$parent.phone,
                              expression: "$parent.phone"
                            }
                          ],
                          staticClass:
                            "block border rounded-md w-full p-3 mb-2",
                          attrs: {
                            type: "phone",
                            id: "phone",
                            autocomplete: "off",
                            list: "phonesList",
                            placeholder: "nº teléfono obligatorio"
                          },
                          domProps: { value: _vm.$parent.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$parent,
                                "phone",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "datalist",
                          { attrs: { id: "phonesList", autocomplete: "off" } },
                          _vm._l(_vm.$root.user_phones, function(ph, i) {
                            return _c("option", {
                              key: i,
                              domProps: { value: ph }
                            })
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "block text-left text-md mb-2",
                      attrs: { for: "reason" }
                    },
                    [_vm._v("Motivo (*)")]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$parent.reason,
                        expression: "$parent.reason"
                      }
                    ],
                    staticClass: "block border rounded-md w-full p-3",
                    attrs: { id: "reason", rows: "5" },
                    domProps: { value: _vm.$parent.reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.$parent, "reason", $event.target.value)
                      }
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "bg-gray-50 py-3 flex flex-row-reverse justify-center gap-5"
        },
        [
          _vm.$parent.isFormOk
            ? _c(
                "button",
                {
                  staticClass:
                    "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-400 text-2xl font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                  attrs: { type: "button" },
                  on: { click: _vm.$parent.createAppointment }
                },
                [_vm._v("\n            Continuar 〉\n        ")]
              )
            : _c(
                "span",
                {
                  staticClass:
                    "text-gray-400 bg-gray-300 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-400 text-2xl font-medium"
                },
                [_vm._v("\n            Continuar 〉\n        ")]
              ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-2xl font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$parent.$parent.creatingAppointment = false
                }
              }
            },
            [_vm._v("\n            〈 Atrás\n        ")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }